import React, { useContext, useEffect, useState } from "react";
import moveTeamImg from "../../../../assets/moveTeamImg";
import accountSvg from "../../../../assets/accountSvg";
import { AppContext } from "../../../../AppContext";
import pencilSvg from "../../../../assets/pencilSvg";
import EditNotesModal from "../ClientModals/EditNoteModal";
import { EditNoteContext } from "./EditNoteContext";

const PendingPanel = ({
  index,
  clientName,
  loanOfficerName,
  loanOfficerEmail,
  agentPartner,
  agentEmail,
  stage,
  loNotes,
  agentNotes,
  id,
  coAgentName,
  loanOfficerPhone,
  agentPhone,
  coAgentPhone,
  loanOfficerTextNotifications,
  agentTextNotifications,
  coAgentTextNotifications,
}) => {
  const {
    pendingPanelsController,
    setPendingPanelsController,
    userType,
    userName,
  } = useContext(AppContext);

  const [panelAdd, setPanelAdd] = useState("hidden");
  const [noteEdit, setNoteEdit] = useState("hidden");
  const [notes, setNotes] = useState(
    userType == "Loan Officer" ? loNotes : agentNotes
  );

  useEffect(() => {
    setPanelAdd(
      pendingPanelsController[index] == true ||
        pendingPanelsController[index] == undefined
        ? "hidden"
        : ""
    );
  }, [pendingPanelsController]);

  useEffect(() => {
    setNotes(userType == "Loan Officer" ? loNotes : agentNotes);
  }, [id]);

  let pendingStatus;
  const progressDots = () => {
    let number;
    switch (stage) {
      case "New Lead":
        number = 0;
        pendingStatus = "Reaching out to client ASAP";
        break;
      case "Attempting Contact":
        number = 1;
        pendingStatus = `Waiting for client's response`;
        break;
      case "Appointment Scheduled":
        number = 2;
        pendingStatus = "Meeting with client soon";
        break;
      case "Application Sent":
        number = 3;
        pendingStatus = "Client to complete application";
        break;
      case "Docs Requested":
        number = 4;
        pendingStatus = "Client to provide docs";
        break;
      case "Docs Received":
        number = 5;
        pendingStatus = "Preparing pre-approval now";
        break;
    }
    let circles = [];
    for (let i = 0; i < 6; i++) {
      if (i <= number) {
        circles.push(<div className="stageCircle fill" key={i}></div>);
      } else {
        circles.push(<div className="stageCircle" key={i}></div>);
      }
    }
    return circles;
  };

  let loanOfficerNote = [];
  let agentNote = [];

  const userIsLo =
    userType === "Loan Officer" && loanOfficerName.includes(userName);
  const userIsAgent = userType === "Agent" && agentPartner.includes(userName);
  let userIsCoAgent = false;
  if (coAgentName) {
    userIsCoAgent = userType === "Agent" && coAgentName.includes(userName);
  }

  loanOfficerNote = (
    <>
      {loNotes ? (
        <>
          <div
            className={`chatMessage ${userIsLo ? "blueChat" : null}`}
            onClick={(e) => {
              if (userIsLo) {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }
            }}
          >
            <div className="chatMessageNotes">{loNotes}</div>
            {userIsLo ? (
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            ) : null}
          </div>
        </>
      ) : (
        <>
          {userIsLo ? (
            <div
              className="button addNotes"
              onClick={(e) => {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }}
            >
              Add Notes
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            </div>
          ) : (
            <div className="chatName">
              No notes. Check in with {loanOfficerName} for updates.
            </div>
          )}
        </>
      )}
    </>
  );

  agentNote = (
    <>
      {agentNotes ? (
        <>
          <div
            className={`chatMessage ${
              userIsAgent || userIsCoAgent ? "blueChat" : null
            }`}
            onClick={(e) => {
              if (userIsAgent || userIsCoAgent) {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }
            }}
          >
            <div className="chatMessageNotes">{agentNotes}</div>
            {userIsAgent || userIsCoAgent ? (
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            ) : null}
          </div>
        </>
      ) : (
        <>
          {userIsAgent || userIsCoAgent ? (
            <div
              className="button addNotes"
              onClick={(e) => {
                e.stopPropagation();
                noteEdit === "hidden" ? setNoteEdit("") : setNoteEdit("hidden");
              }}
            >
              Add Notes
              <div className={`pencil-circle ${userType}`}>{pencilSvg}</div>
            </div>
          ) : (
            <div className="chatName">
              No notes. Check in with{" "}
              {coAgentName ? `${agentPartner} & ${coAgentName}` : agentPartner}{" "}
              for updates.
            </div>
          )}
        </>
      )}
    </>
  );

  return (
    <div className="clientPanel hover">
      <EditNoteContext.Provider
        value={{
          noteEdit,
          setNoteEdit,
          notes,
          setNotes,
          userType,
          id,
          loanOfficerName,
          loanOfficerEmail,
          agentPartner,
          agentEmail,
          clientName,
          coAgentName,
          loanOfficerPhone,
          agentPhone,
          coAgentPhone,
          loanOfficerTextNotifications,
          agentTextNotifications,
          coAgentTextNotifications,
        }}
      >
        <div
          className="pendingContainer"
          onClick={() => {
            panelAdd === "hidden" ? setPanelAdd("") : setPanelAdd("hidden");
            let arrayOfPanels = [];
            for (
              let i = 0;
              i < document.getElementsByClassName("pendingPanelAdd").length;
              i++
            ) {
              if (
                pendingPanelsController[index] != undefined
                  ? pendingPanelsController[index] && i == index
                  : i == index
              ) {
                arrayOfPanels.push(false);
              } else {
                arrayOfPanels.push(true);
              }
            }
            setPendingPanelsController(arrayOfPanels);
          }}
        >
          <div className="containerLeft">
            <div className="clientName">{clientName}</div>
          </div>
          <div className={`progressbar ${panelAdd}`}>{progressDots(3)}</div>
          <div className={`contact ${panelAdd}`}>
            {moveTeamImg}
            <span className="contactText">{loanOfficerName}</span>
            <div className={`pendingPanelAdd ${panelAdd}`}>
              {loanOfficerNote}
            </div>
          </div>
          <div className={`contact ${panelAdd}`}>
            {accountSvg}
            <span className="contactText">
              {coAgentName ? `${agentPartner} & ${coAgentName}` : agentPartner}
            </span>
            <div className={`pendingPanelAdd ${panelAdd}`}>{agentNote}</div>
          </div>
          <div className={`containerRightPending ${panelAdd}`}>
            <span className="stage">{pendingStatus}</span>
          </div>
        </div>
        <EditNotesModal />
      </EditNoteContext.Provider>
    </div>
  );
};

export default PendingPanel;
